<template>
  <!-- 剧集抽屉 -->
  <a-drawer
    :title="detail.name"
    width="700"
    :closable="false"
    :visible="visible"
    @close="onClose"
    :footer-style="{ textAlign: 'right' }"
  >
    <a-tabs v-model:activeKey="activeKey" v-if="visible">
      <a-tab-pane :key="1" tab="任务详情">
        <DetailView :detail="detail"></DetailView>
      </a-tab-pane>
    </a-tabs>
    <!-- 加载 -->
    <Loading :loading="isLoading"></Loading>
  </a-drawer>
</template>

<script setup>
import { ref, reactive, defineExpose, nextTick } from 'vue'
import { XinTuStateTypes } from '@/utils/constantList'
import Loading from '@/components/Loading'
import DetailView from './DetailView.vue'

// 回调
const emit = defineEmits('success')
// 是否展示弹窗
let visible = ref(false)
// id
let detail = ref({})
// 加载
let isLoading = ref(false)
// 选中
let activeKey = ref(1)


// 打开抽屉
function showDrawer (params) {
  // 展开
  visible.value = true
  // 详情
  detail.value = params
}

// 关闭弹窗
function onClose () {
  visible.value = false
}

defineExpose({
  showDrawer
})

</script>

<style lang="less" scoped>
</style>